import React, { useEffect, useState } from "react";
import LineBox from "../../../../DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import MatchMakingEmailFilter, {
  matchMakingEmailFilter,
} from "./components/N_MatchMakingEmailFilter";
import LineBtn from "../../../../Button/LineBtn";
import MatchMakingEmailInfoModal from "./components/N_MatchMakingEmailInfoModal";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../../ApiTS/ServiceDatasTS";
import { useApi } from "../../../../../hooks/useApi";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../../pages/Login";
import { toast } from "react-toastify";
import SpaceBetween from "../../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../../Table/Pagination";
import { TotalCount } from "../../../../../pages/Users/UserInfo";
import { decryptPW, getThousandComma } from "../../../../../Api/ApiCommon";
import Loader from "../../../../DefaultStyles/Loader";
import { useNavigate } from "react-router-dom";
import PartyMailModal from "../../PartyDetail/PartyDetailShareInfo/PartyMailModal";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

export interface IMatchPartyEmail {
  id: number;
  email: string;
  comment?: string;
  partyid?: number[];
  password?: string;
  servsubsid: number;
}

interface AccDatas {
  map(
    arg0: (d: IMatchPartyEmail) => import("react/jsx-runtime").JSX.Element
  ): unknown;
  email: string;
  data: IMatchPartyEmail[];
}

export default function MatchMakingEmail() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const filter = useRecoilValue(matchMakingEmailFilter);
  const [page, setPage] = useState(0);
  const [emailInfoModal, setEmailInfoModal] = useState<{
    modal: boolean;
    data?: IMatchPartyEmail;
  }>({
    modal: false,
    data: undefined,
  });
  const [linkidMailModal, setLinkidMailModal] = useState({
    modal: false,
    email: "",
  });

  const [groupedByEmail, setGroupedByEmail] = useState(new Map());

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: auth?.adminSet
      ? `matchParty/NewAccountList?page=${page}&size=10` +
        (filter?.searchValue !== "" ? `&email=${filter?.searchValue}` : ``) +
        (filter?.subsId !== "" ? `&servsubsid=${filter?.subsId}` : ``) +
        (filter?.using !== "" && filter?.using !== "all"
          ? `&isUsing=${filter?.using}`
          : ``)
      : undefined,
  });

  console.log("dkjdkfjdkfjdkfd   ", response?.data);

  const tableHead = [
    "No",
    "아이디",
    "Subscription",
    "상태",
    // "이메일",
    // "비밀번호",
    "확인/수정",
    // "코멘트",
    "파티확인",
  ];

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "이메일 리스트를 가져오는 데에 실패하였습니다."
      );
    }
  }, [error]);

  useEffect(() => {
    groupedByEmail.clear();
    const groupedByEmailData = new Map();
    response?.data?.items.forEach((item: { email: any }) => {
      if (!groupedByEmailData.has(item.email)) {
        groupedByEmailData.set(item.email, []);
      }
      groupedByEmailData.get(item.email).push(item);
    });

    setGroupedByEmail(groupedByEmailData);
  }, [response?.data]);

  const linkedSubsList = (list: IMatchPartyEmail[]) => {
    let listName: string[] = [];
    list.map((d: IMatchPartyEmail) => {
      listName.push(d?.servsubsid + "_" + getSubsNameBySubsId3(d?.servsubsid));
    });
    console.log("listName    ", listName.join("\n"));

    return listName.join("\n");
  };

  return (
    <>
      <MatchMakingEmailFilter
        refetch={() =>
          fetchData({
            method: "get",
            url: auth?.adminSet
              ? `matchParty/NewAccountList?page=${page}&size=10`
              : undefined,
          })
        }
      />

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {Array.from(groupedByEmail).map(([email, group], index) => {
              console.log("22222   ", email, group, index);

              return (
                <TableBody key={index}>
                  <TableBodyItem>{group[0].id}</TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() =>
                      setLinkidMailModal({
                        modal: true,
                        email: email,
                      })
                    }
                  >
                    {email}
                  </TableBodyItem>
                  <TableBodyItem>
                    <pre>{linkedSubsList(group)}</pre>
                  </TableBodyItem>
                  <TableBodyItem>
                    {group[0].state === 1 ? "활성" : "비활성"}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="수정하기"
                      // disabled={d?.partyid && d?.partyid?.length > 0}
                      btnClickEvent={() =>
                        setEmailInfoModal({
                          modal: true,
                          data: group,
                        })
                      }
                    />
                  </TableBodyItem>
                </TableBody>
              );

              group.map((d: IMatchPartyEmail) => {
                const subsData = GetSubscriptionSetData(d?.servsubsid ?? 0);
                const svcData = GetServiceSetData(subsData?.SVC_ID ?? 0);
                console.log(subsData);

                return (
                  <TableBody key={d?.id}>
                    <TableBodyItem>{d?.id}</TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      {d?.servsubsid
                        ? getSubsNameBySubsId3(d?.servsubsid) ?? "-"
                        : "-"}
                    </TableBodyItem>
                    <TableBodyItem>
                      {svcData?.SVC_NMKR_TEMP ?? ""}_{d?.id}
                    </TableBodyItem>
                    <TableBodyItem
                      clickable={true}
                      onClick={() =>
                        setLinkidMailModal({
                          modal: true,
                          email: d?.email,
                        })
                      }
                    >
                      {d?.email}
                    </TableBodyItem>
                    <TableBodyItem>
                      {d?.password ? decryptPW(d?.password, 1)?.pw : "-"}
                    </TableBodyItem>
                    <TableBodyItem isKeepAll={true}>
                      {d?.partyid
                        ? d?.partyid?.map((p, i) => (
                            <>
                              <span
                                key={p}
                                onClick={() => navigate(`/party/info/${p}`)}
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                {p}
                              </span>

                              {i !== d?.partyid?.length! - 1 && <>{", "}</>}
                            </>
                          ))
                        : "-"}
                    </TableBodyItem>
                    {/* <TableBodyItem isKeepAll={true}>
                      {d?.comment ?? "-"}
                    </TableBodyItem> */}
                    <TableBodyItem>
                      <LineBtn
                        btnText="수정하기"
                        disabled={d?.partyid && d?.partyid?.length > 0}
                        btnClickEvent={() =>
                          setEmailInfoModal({
                            modal: true,
                            data: d,
                          })
                        }
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              });
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}

      {emailInfoModal.modal && (
        <MatchMakingEmailInfoModal
          closeEvent={() =>
            setEmailInfoModal({
              modal: false,
              data: undefined,
            })
          }
          data={emailInfoModal.data}
          refetch={() =>
            fetchData({
              method: "get",
              url: auth?.adminSet
                ? `matchParty/NewAccountList?page=${page}&size=10`
                : undefined,
            })
          }
        />
      )}

      {linkidMailModal.modal && (
        <PartyMailModal
          closeEvent={() =>
            setLinkidMailModal({
              modal: false,
              email: "",
            })
          }
          mailId={linkidMailModal.email}
          type={
            linkidMailModal.email?.includes("testgrove.pw") ||
            linkidMailModal.email?.includes("linkidmail.com")
              ? "db"
              : "mailgun"
          }
        />
      )}
    </>
  );
}
